/** @format */

const ServiziTranslations = {
  en: {
    'Header.servizi1': 'Discover ',
    'Header.servizi2': 'services',
    'Header.servizi3':
      'Here you can easily and quickly access a large number of services that will allow you to find the help you need.',
    'Servizi.Tab': 'All',
    'Servizi.Tab1': 'Family support',
    'Servizi.Tab2': 'Well-being of the person',
    'Servizi.Tab3': 'Domestic activities',
    'Servizi.Tab4': 'Services of the municipality of Milan',
    'Servizi.Button': 'More info',
    'Servizi.Button1': 'More info',
    'Servizi.Button2': 'More info',
    'Servizi.Button3': 'More info',
    'Servizi.Button4': 'More info',
    'Servizi.Button5': 'More info',
    'Servizi.Button6': 'More info',
  },
  it: {
    'Header.servizi1': 'Scopri i',
    'Header.servizi2': 'servizi',
    'Header.servizi3': 'Clicca sulla categoria di tuo interesse per scoprire con semplicità tutti i servizi.',
    'Servizi.Tab': 'Tutti',
    'Servizi.Tab1': 'Sostegno alla famiglia',
    'Servizi.Tab2': 'Benessere della persona',
    'Servizi.Tab3': 'Attività domestiche',
    'Servizi.Tab4': 'Servizi del comune di Milano',
    'Servizi.Button': 'Scopri',
    'Servizi.Button1': 'Scopri',
    'Servizi.Button2': 'Scopri',
    'Servizi.Button3': 'Scopri',
    'Servizi.Button4': 'Scopri',
    'Servizi.Button5': 'Scopri',
    'Servizi.Button6': 'Scopri',
  },
};

export default ServiziTranslations;
